let extConfig = window.APP_CONFIG || { };
export default window.APP_CONFIG = Object.assign({}, extConfig, {
    TRANSLATION: {
        SEARCH_WIDGET: {
            "destination": "Destination/Hotel", 
            "departure": "Afgang", 
            "departure_airport": "Afrejselufthavn", 
            "home_arrival": "Hjemkomst", 
            "number_of_travelers": 
            "Antal rejsende", 
            "search": "SØG", 
            "search_txt": "Land, by eller hotel....", 
            "calendar_title": "Hjemkomst/Afrejse", 
            "number_of_adults": "Antal voksne", 
            "number_of_children": "Antal børn", 
            "grouptravel": "Flere værelser? Klik her", 
            "adults": "voksne", 
            "adult_single": "voksen", 
            "children": "børn", 
            "children_single": "barn", 
            "departure_airports": { "HAM": "Hamborg", "RLG": "Rostock", "TXL,BER,SXF": "Berlin" }, 
            "children_ages": "Barn {n} alder", 
            "choose_start_date": "Vælg start dato", 
            "choose_end_date": "Vælg slut dato", 
            "ok_btn": "OK", "type_hotel": "Hotel", 
            "type_location": "Destination", 
            "type_region": "Region", 
            "ERRORS": {
                    "from_date": "Tidspunkt mangler at blive udfydlt", 
                    "from_date_past": "Tidspunkt skal være i fremtiden", 
                    "to_date_past": "Tidspunkt skal være efter afrejsedato", 
                    "to_date": "Tidspunkt mangler at blive udfyldt", 
                    "departure_airport": "Afrejselufthavn skal udfyldes", 
                    "destination_id": "Destination mangler at blive udfydlt", 
                    "adults": "Antallet af voksne mangler at blive udfydlt", 
                    "children": "Antallet af børn mangler at blive udfyldt", 
                    "flexible_days": "Antallet af fleksible dage er ikke numerisk!"
                }
        },
        RANGE_SELECTOR: {"flexible_days_text":"+/- dage","week":"Uge","months":["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"],"short_days":["Ma","Ti","On","To","Fr","Lø","Sø"]},
        GROUP_TRAVELS: {
            "header":"Forespørgsel på grupperejser",
            "guide":[
                "Udfyld nedenstående formular - søg venligst først noget <a href=\"https://skovrejser.dk/inspiration\" target=\"_blank\">inspiration.</a>",
                "Du vil modtage <strong>tilbud fra vores tyske partner, Travianet, pr. mail</strong> i din indbakke (tjek venligst også SPAM-filteret)."
            ],
            "reserveHeader":"Vil du booke en grupperejse?",
            "reserveText":"<a class=\"group-travel-option\" href=\"https://skovrejser.dk/vigtig-information/grupperejsebestilling/book#book\" target=\"_blank\">Book en grupperejse</a>",
            "offerHeader":"Har du fundet et tilbud på vores hjemmeside?",
            "offerText":"Har du fundet 2 eller flere tilbud og vil du gerne booke dem som én gruppe, så send det du har fundet på hjemmesiden til os på <a href=\"mailto:support@skovrejser.dk.\">support@skovrejser.dk.</a>",
            "formHelpHeader":"Bruges til grupper med:",
            "formHeader":"Grupperejsetilbud",
            "input":{
                "preferredlanguage":"Ønsker du tilbuddet på engelsk eller tysk?",
                "preferredlanguageEng":"Engelsk",
                "preferredlanguageGer":"Tysk",
                "preferredlanguageHelp": "(Vi kan dog ikke garantere at det hele er på engelsk)", 
                "adults": "Antal voksne *", 
                "destinations": "Valgte destinationer (maks. 2):", 
                "children": "Antal børn *",
                "noChildren": "Ingen børn", 
                "travelFromDate": "Hvilken dato kan I tidligst rejse fra*", 
                "travelToDate": "Hvilken dato kan I senest rejse hjem\t*", 
                "travelTime": "Rejsevarighed*", 
                "selectTravelTime": "Vælg rejsevarighed...", 
                "selectedTravelTimeDates": "Eksakte rejsedatoer", 
                "day": "dag", 
                "days": "dage", 
                "moreThen6Weeks": "mere end 6 uger", 
                "price": "Budget", 
                "choosenBudget": "Dit valgte budget: ", 
                "budgetHelp": "Træk i den blå knap for at sætte dit budget", 
                "budgetInfo": "Angiv samlet totalbudget for alle rejsende", 
                "noBudget": "Vælg venligst et budget", 
                "hotelCategories": "Hotelkategorier *", 
                "stars": " stjerner", 
                "roomType": "Værelsestype*", 
                "roomCount": "Antal", 
                "roomWarning": "Beskrivelsen er med forbehold og uden ansvar for Skov Rejser, da værelser kan variere lidt fra hotel til hotel. Familieværelse, lejlighed og suite kan f.eks være med både 1 og 2 soveværelser.", 
                "roomTypes": [
                    {
                        "name": "Dobbeltværelse", 
                        "helpTxt": "Værelse med soverum og stue i et. Dobbeltseng eller to senge sat sammen. Mulighed for opredning til 2 børn.", 
                        "key": "Doppelzimmer_count", 
                        "value": "Doppelzimmer"
                    }, 
                    { 
                        "name": "Familieværelse", 
                        "helpTxt": "Soveplads til mindst 3 personer hvoraf to er voksne. Kan være et eller flere værelser", 
                        "key": "Familienzimmer_count", 
                        "value": "Familienzimmer" 
                    }, 
                    {
                        "name": "Enkeltværelse", 
                        "helpTxt": "Værelse med seng til kun en person", 
                        "key": "Einzelzimmer_count", 
                        "value": "Einzelzimmer"
                    },
                    { 
                        "name": "Suite", 
                        "helpTxt": "Separat stue og soveværelse.", 
                        "key": "Suite_count", 
                        "value": "Suite"
                    },
                    { 
                        "name": "Lejlighed", 
                        "helpTxt": "1 eller 2 værelser altid med køkkenfaciliteter. Der er ofte separat soveværelse", 
                        "value": "Appartment", 
                        "key": "Appartment_count" 
                    },
                    {
                        "name": "Bungalow", 
                        "helpTxt": "lejlighed/rækkehus ved jorden / på stueplan.", 
                        "value": "Bungalow",
                        "key": "Bungalow_count"
                    },
                    { 
                        "name": "Studio", 
                        "helpTxt": "et enkelt værelse med seng til en eller to personer og med lidt køkkenfaciliteter", 
                        "value": "Studio", 
                        "key": "Studio_count" 
                    }
                ], 
                "pensionTxt": "Forplejning*", 
                "pension": { 
                    "Ohne Verpflegung": "Ingen forplejning", 
                    "Frühstück": "Morgenmad", "Halbpension": "Halvpension", 
                    "Vollpension": "Fuldpension", 
                    "All Inklusiv": "All inclusive"
                }, 
                "comments": "Kommentarer og ønsker.", 
                "comment_note": "Bemærk, du skal skrive din besked på engelsk eller tysk!", 
                "sex": "Køn", 
                "sexOptions": { "Frau": "Kvinde", "Herr": "Mand" }, 
                "firstName": "Dit fornavn *", 
                "lastName": "Dit efternavn *", 
                "address": "Vejnavn, nr.*", 
                "postal": "Postnummer *", 
                "town": "By *", 
                "phone": "Telefonnummer *", 
                "email": "Email (den der skal stå for bookingen) *", 
                "email_confirm": "Bekræft email *", 
                "newsletter": "Vil du tilmeldes vores nyhedsbrev nu hvor du er i gang?", "submit": "Indsend formular"
                }, 
            "successMsg": "Din forespørgsel er blevet sendt.", 
            "ERRORS": { 
                "kategoriLimit": "Du må maksimalt afkrydse 2 hotelkategorier.", 
                "destinations": "Du skal vælge mindst én destination før du kan fortsætte.", 
                "duration": "Du skal angive rejsens varighed", "budget": "Du skal angive et budget for rejsen", 
                "kategori": "Du skal angive mindst én hotelkategori", 
                "roomtype": "Du skal angive mindst én værelsestype", 
                "childage": "Du skal angive alle børnenes alder", 
                "roomcount": "Du skal angive ønsket antal for alle værelsestyper", 
                "children": "Antal børn i værelser stemmer ikke overens med total antal rejsende børn.", 
                "adults": "Antal voksne i værelser stemmer ikke overens med total antal rejsende voksne.", 
                "firstName": "Du skal indtaste dit fornavn.", 
                "lastName": "Du skal indtaste dit efternavn.", 
                "address": "Du skal indtaste din adresse.", 
                "zipCode": "Du skal indtaste dit postnummer.", 
                "zipCode_tooshort": "Du har ikke indtastet et postnummer", 
                "city": "Du skal indtaste bynavn.", 
                "phone": "Du skal indtaste telefonnummer.", 
                "email": "Du skal indtaste e-mail.", 
                "email_not_valid": "Check at du har skrevet en gyldig email adresse.", 
                "email_not_equal": "Check at email er bekræftiget korrekt.", 
                "submiterror": "Der skete en fejl og din forespørgsel kunne ikke blive sendt!", 
                "hasErrors": "Formularen indholdeholder fejl! Gennemgå den venligst igen...", 
                "fromdate": "Fra dato skal udfyldes.", 
                "todate": "Til dato skal udfyldes.", 
                "date_error": "Du har ikke indtastet en gyldig datoperiode."
            }
        }
    },
    MAX_AGE_CHILDREN: 16,
    THEME_PATH: 'https://skovrejser.dk/application/themes/skovrejser',
    APP_URL: 'https://skovrejser.dk',
	API_ENDPOINT: 'https://api.skovrejser.dk/'
});